import * as userRequest from "@/utils/userRequest";

export default async function comfirmOTPClaimService(
    otp: string,
    type: string,
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post(
            "auth/confirm-otp-claim",
            {
                otp,
                type,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ comfirmOTPClaimService ~ err:", err);
        handleError && handleError(err);
        throw err;
        //
    }
}
